import React, { useState, useEffect } from "react";
import packageJson from "../package.json";
import moment from "moment";
import ClearCacheLoader from "./components/commonComponents/ClearCacheLoader";

const buildDateGreaterThan = (latestDate, currentDate) => {
  const serverBuildDate = moment(latestDate);
  const localBuildDate = moment(currentDate);
  return serverBuildDate.isAfter(localBuildDate);
};

function withClearCache(Component) {
  function ClearCacheComponent(props) {
    const [isLatestBuildDate, setIsLatestBuildDate] = useState(false);

    useEffect(() => {
      checkForUpdates();
    }, []);

    const checkForUpdates = async () => {
      try {
        // Always fetch meta.json from network, bypass all caches
        const response = await fetch("/meta.json", {
          cache: "no-store",
          headers: {
            "Pragma": "no-cache",
            "Cache-Control": "no-cache",
          },
        });

        if (!response.ok) {
          console.warn("Failed to fetch meta.json, proceeding with current version");
          setIsLatestBuildDate(true);
          return;
        }

        const meta = await response.json();
        const serverBuildDate = meta.buildDate;
        const localBuildDate = packageJson.buildDate;

        const shouldForceRefresh = buildDateGreaterThan(serverBuildDate, localBuildDate);

        if (shouldForceRefresh) {
          console.log("New version detected, clearing cache and reloading...");
          await refreshCacheAndReload();
        } else {
          setIsLatestBuildDate(true);
        }
      } catch (error) {
        console.warn("Version check failed, proceeding with current version:", error);
        setIsLatestBuildDate(true);
      }
    };

    const refreshCacheAndReload = async () => {
      try {
        // Clear all caches
        if ("caches" in window) {
          const cacheNames = await caches.keys();
          await Promise.all(cacheNames.map((name) => caches.delete(name)));
        }

        // Unregister all service workers and wait for completion
        if ("serviceWorker" in navigator) {
          const registrations = await navigator.serviceWorker.getRegistrations();
          await Promise.all(registrations.map((reg) => reg.unregister()));
        }

        // Force reload from server
        window.location.reload();
      } catch (error) {
        console.error("Cache clearing failed:", error);
        window.location.reload();
      }
    };

    if (!isLatestBuildDate) {
      return <ClearCacheLoader />;
    }

    return <Component {...props} />;
  }

  return ClearCacheComponent;
}

export default withClearCache;